module.exports = __webpack_public_path__ + "img/photo11.ebdcee45.jpg";